import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-canned-replies',
  templateUrl: './ui-canned-replies.component.html',
  styleUrls: ['./ui-canned-replies.component.scss']
})
export class UiCannedRepliesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  note:string = '';
  noteSelected: number = -1;
  noteCannedReply(indx:number) {
    switch(Number(indx)) {
      case -1: this.note = '';
        break;
      case 0: this.note = 'Please have a look at the ';
        break;
      case 1: this.note = 'Requesting additional investigation for ';
        break;
      case 2: this.note = 'Required Documents are not in place. Kindly do a through verification for ';
        break;
    }
  }


}
